(function () {
    function initPersonalizePopup(root) {
        var context = root || document;
        var popup = context.querySelector('.personalize-popup');
        if (!popup) return;

        var triggers = document.querySelectorAll('.btn-popup');

        function openPopup(event) {
            if (event) {
                event.preventDefault();
            }

            // Debug helper so you can confirm JS is running

            popup.removeAttribute('hidden');
            popup.setAttribute('open', '');
            popup.setAttribute('active', '');
        }

        function closePopup(event) {
            if (event) {
                event.preventDefault();
            }
            popup.removeAttribute('open');
            popup.removeAttribute('active');
        }

        if (triggers.length) {
            triggers.forEach(function (trigger) {
                trigger.addEventListener('click', openPopup);
            });
        }

        var openInitially = popup.getAttribute('data-open-initial') === 'true';
        if (openInitially) {
            openPopup();
        }

        popup.addEventListener('click', function (event) {
            var closeTarget = event.target.closest('[data-popup-close]');
            if (closeTarget) {
                closePopup(event);
            }
        });

        document.addEventListener('keyup', function (event) {
            if (event.key === 'Escape' && !popup.hidden) {
                closePopup(event);
            }
        });
    }

    // Run on initial load (both live store and editor)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initPersonalizePopup(document);
        });
    } else {
        initPersonalizePopup(document);
    }

    // Run again when Shopify dynamically loads sections in the theme editor
    document.addEventListener('shopify:section:load', function (event) {
        if (!event.target) return;
        if (event.target.querySelector('.personalize-popup') || event.target.querySelector('.btn-popup')) {
            initPersonalizePopup(document);
        }
    });
})();
